import React from "react";
import Header from "../components/Header";
import './about.css';
import PhoneIcon from '../assets/phone-call.svg';
import MapPinIcon from '../assets/map-pin.svg';
import EmailIcon from '../assets/mail.svg';
import ClockIcon from '../assets/clock.svg';
import ClinicFrontImage from '../assets/clinic-front.jpeg';

export default function AboutUs() {
  return (
    <div className="about-page">
      <Header />

      <div className="about-hero-banner">
          <h1 className="about-title">About Us</h1>
      </div>
      <div className="about-main-container">
        
        <div className="about-text-content">
          <p>
              Welcome to <strong>Oculus Eye Hospital</strong>, the newest state-of-the-art eye care facility in Nagaon. 
              We opened our doors with a singular mission: to blend advanced medical technology with 
              warm, personalized care that treats you like family, not just a patient.
          </p>
          <p>
              Though our facility is new, our commitment to excellence is timeless. We have equipped our 
              clinic with the latest diagnostic tools to detect issues early and treat them effectively. 
              From routine vision corrections to comprehensive eye health management, we are here to ensure 
              you see the world clearly. Experience the difference of a clinic that puts your vision first.
          </p>
        </div>
        </div>

        <section className="contact-split-card">
          
        <div className="contact-details-column">
            <h2>Visit Us Today</h2>
            <p className="contact-subtext">We are ready to serve you.</p>
            
            <div className="info-grid">
              
              <div className="info-row">
                <span className="info-icon">
                    <img src= {MapPinIcon} alt="Map-Pin" className="map-pin-icon"/>
                </span>
                <div>
                  <strong>Address:</strong>
                  <p>Haibargaon, Khutikatia<br/>Nagaon, Assam - 782002</p>
                </div>
              </div>

              <div className="info-row">
                <span className="info-icon">
                  <img src= {ClockIcon} alt="Clock" className="clock-icon"/>

                </span>
                <div>
                  <strong>Opening Hours:</strong>
                  <p>Everyday (includes Sundays ) : 9:00 AM - 6:00 PM</p>
                </div>
              </div>

              <div className="info-row">
                <span className="info-icon">
                  <img src= {PhoneIcon} alt="Phone" className="phone-icon"/>

                </span>
                <div>
                  <strong>Phone:</strong>
                  <p><a href="tel:+916000678383">+91 6000678383</a></p>
                </div>
              </div>

              <div className="info-row">
                <span className="info-icon">
                  <img src= {EmailIcon} alt="Email" className="email-icon"/>

                </span>
                <div>
                  <strong>Email:</strong>
                  <p><a href="info@oculuseyehospitalassam.com">info@oculuseyehospitalassam.com</a></p>
                </div>
              </div>

            </div>
          </div>

          <div className="contact-image-column">
            <img 
              src={ClinicFrontImage} 
              alt="Our Clinic Entrance" 
              className="clinic-photo"
              onError={(e) => {e.target.src = '/assets/clinic-front.jpeg'}}
            />
          </div>

        </section>
    </div>
  );
}